import VehicleInfoList from './vehicle-info-list.vue'
export default VehicleInfoList
